import { render, staticRenderFns } from "./CreateGlobalAccount.vue?vue&type=template&id=955d2cf0&scoped=true&"
import script from "./CreateGlobalAccount.vue?vue&type=script&lang=js&"
export * from "./CreateGlobalAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateGlobalAccount.vue?vue&type=style&index=0&id=955d2cf0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955d2cf0",
  null
  
)

export default component.exports